import { ScrollOptions, IScrollTopOptions } from '../../models/kt';


export const defaultScrollOptions: ScrollOptions = {
   saveState: true,
}

export const defaultScrollTopOptions: IScrollTopOptions = {
   offset: 200,
   speed: 600,
}
